import React from "react";
import {EditGuesser} from "@api-platform/admin";

const CardGameEdit = props => (
        <EditGuesser {...props} resource="card-games"/>
);

export default CardGameEdit;
